declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/**
 * Returns a `trackEvent` helper that fires a GA4 custom event via gtag.
 * No-ops silently if gtag hasn't been injected (e.g. in dev), so components
 * never need to guard the call site.
 */
export function usePlausible() {
  function trackEvent(
    name: string,
    props?: Record<string, string | number | boolean>,
  ) {
    try {
      window.gtag?.("event", name, props ?? {});
    } catch {
      // never throw — analytics must never break the app
    }
  }

  return { trackEvent };
}
